import {
  axiosSysApi,
  axiosDataApi
} from '../../axios_init'

import {
  saveEleCase,
  clearEleCase,
  getEleCase
} from '@/api/ele_local'

const state = {
  // 0 start 10 获取原始数据完成 20 选择case完成  30 求解完成
  ele_status: 0,
  source_data_ele: [],
  cases_ele: [],
  show_cases_name: [],
  compare_cases_name: [],
  all_save_cases_name: []
}

const getters = {
  allSaveCasesName: state => state.all_save_cases_name,
  compareCasesName: state => state.compare_cases_name,
  showCasesName: state => state.show_cases_name,
  eleStatus: state => state.ele_status,
  sourceDataEle: state => state.source_data_ele,
  casesEle: state => state.cases_ele
}

const actions = {
  getAllSaveCasesName ({ commit }) {
    let allSaveCase = getEleCase() || []
    let data = []
    allSaveCase.forEach(function (item) {
      data.push(item.name)
    })
    commit('changeAllSaveCasesName', data)
  },
  saveOneEleCase ({ commit, dispatch }, caseData) {
    saveEleCase(caseData)
    dispatch('getAllSaveCasesName')
  },
  clearOneEleCase ({ commit, dispatch }, caseName) {
    clearEleCase(caseName)
    dispatch('getAllSaveCasesName')
  },
  oupoutEleCase ({ commit, dispatch }, nameList) {
    let newCaseData = getEleCase(nameList)
    newCaseData.forEach(function (item) {
      dispatch('addCasesEle', item)
    })
  },
  setCompareCasesName ({ commit }, data) {
    commit('changeCompareCasesName', data)
  },
  setShowCasesName ({ commit }, data) {
    commit('changeShowCasesName', data)
  },
  setEleStatus ({ commit }, data) {
    commit('changeEleStatus', data)
  },
  setSourceDataEle ({ commit, dispatch }, data) {
    commit('changeSourceDataEle', data)
    dispatch('setEleStatus', 10)
  },
  addCasesEle ({ commit, dispatch }, data) {
    if (data.status < 30) {
      data.status = 20
      commit('pushCasesEle', data)
      dispatch('startSolutionEle', data)
    } else {
      commit('pushCasesEle', data)
    }
  },
  setCasesEle ({ commit }, data) {
    commit('changeCasesEle', data)
  },
  setCaseResultEle ({ commit }, data) {
    commit('changeCaseResultEle', data)
  },
  loadSourceDataEle ({ commit, getters, dispatch }, data) {
    dispatch('setLoading', true)
    dispatch('setLoadingText', '获取数据中')
    dispatch('setPercentage', {'start': 0, 'next': 100})
    axiosSysApi.get('/static/ele_source_data.json').then(function (response) {
      dispatch('setSourceDataEle', response.data)
      dispatch('setLoadingText', '获取数据完成')
      dispatch('setPercentage', {'start': 100, 'next': 100})
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '获取数据异常',
        message: '错误信息:' + e
      })
      dispatch('setEleStatus', 0)
      dispatch('setLoadingText', '获取数据异常')
      dispatch('setPercentage', {'start': 100, 'next': 100})
      console.log(e)
    })
  },
  startSolutionEle ({ commit, getters, dispatch }, data) {
    let postData = {
      '天气': data.d1,
      '光伏成本': data.d2,
      '固定存储容量': Number(data.d3.split('k')[0]),
      'SOC下限': data.d4,
      'SOC上限': data.d5,
      'SOC初始值': data.d6,
      '储能放电成本': data.d7,
      generator: getters.sourceDataEle.generator,
      grid_price: getters.sourceDataEle.grid_price,
      load: getters.sourceDataEle.load,
      new_eng: getters.sourceDataEle.new_eng,
      period: getters.sourceDataEle.period,
      solver: 'microgrid'
    }
    axiosDataApi.post('/solve', window.JSON.stringify(postData)).then(function (response) {
      dispatch('setCaseResultEle', {data: response.data, caseName: data.name})
    }).catch(function (e) {
      dispatch('showNoticeMsg', {
        type: 'error',
        title: '求解异常',
        message: '错误信息:' + e
      })
      console.log(e)
    })
  }
}

const mutations = {
  changeCaseResultEle (state, data) {
    state.cases_ele.forEach(function (item) {
      if (item.name === data.caseName) {
        item.result = data.data
        item.status = 30
      }
    })
  },
  changeAllSaveCasesName (state, data) {
    state.all_save_cases_name = data
  },
  changeCompareCasesName (state, data) {
    state.compare_cases_name = data
  },
  changeShowCasesName (state, data) {
    state.show_cases_name = data
  },
  changeEleStatus (state, data) {
    state.ele_status = data
  },
  changeSourceDataEle (state, data) {
    state.source_data_ele = data
  },
  changeCasesEle (state, data) {
    state.cases_ele = data
  },
  pushCasesEle (state, data) {
    state.cases_ele.push(data)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ele.js